$(document).ready(function () {
  $('.sliderOwl .owl-carousel').owlCarousel({
    animateOut: 'fadeOut',
    animateIn: 'fadeIn',
    items: 1,
    margin: 0,
    stagePadding: 0,
    smartSpeed: 450,
    autoplay: true,
    autoplayTimeout: 7000,
    nav: true,
    center: true,
    loop: true,
    autoplayHoverPause: true,
  });

  $('#arrivalH9, #arrival, #departure,#departureH9').datepicker({
    dateFormat: 'dd.mm.yy',
    showOtherMonths: true,
    selectOtherMonths: true
  });

  $('.hasDatepicker').on('click', function (e) {
    e.preventDefault();
    $('.ui-datepicker').addClass('active');
  });

  $('.formBooking').each(function(i, elem) {
    this.addEventListener('submit', function() {
      $('.checkin').each(function(i, elem) {
        if($(elem).val() !== '') {
          var checkinDayValue = this.value.split('.')[0];
          var checkinYearMonthValue = this.value.split('.')[2] + '-' + this.value.split('.')[1].replace(/^0+/, '');
          $("input[name='checkin_monthday']").each(function(i, elem) {
            this.value = checkinDayValue;
          });
          $("input[name='checkin_year_month']").each(function(i, elem) {
            this.value = checkinYearMonthValue;
          });
        }
      });
      $('.checkout').each(function(i, elem) {
        if($(elem).val() !== '') {
          var checkoutDayValue = this.value.split('.')[0];
          var checkoutYearMonthValue = this.value.split('.')[2] + '-' + this.value.split('.')[1].replace(/^0+/, '');
          $("input[name='checkout_monthday']").each(function(i, elem) {
            this.value = checkoutDayValue;
          });
          $("input[name='checkout_year_month']").each(function(i, elem) {
            this.value = checkoutYearMonthValue;
          });
        }
      });
    });
  });

  

  $.datepicker.regional[window.Laravel.lang.datapicker.lang] = {
    closeText: window.Laravel.lang.datapicker.close,
    prevText: window.Laravel.lang.datapicker.prev,
    nextText: window.Laravel.lang.datapicker.next,
    currentText: window.Laravel.lang.datapicker.current,
    monthNames: [
      window.Laravel.lang.datapicker.months.january,
      window.Laravel.lang.datapicker.months.february,
      window.Laravel.lang.datapicker.months.march,
      window.Laravel.lang.datapicker.months.april,
      window.Laravel.lang.datapicker.months.may,
      window.Laravel.lang.datapicker.months.june,
      window.Laravel.lang.datapicker.months.july,
      window.Laravel.lang.datapicker.months.august,
      window.Laravel.lang.datapicker.months.september,
      window.Laravel.lang.datapicker.months.october,
      window.Laravel.lang.datapicker.months.november,
      window.Laravel.lang.datapicker.months.december
    ],
    monthNamesShort: [
      window.Laravel.lang.datapicker.months.january.slice(0, 3),
      window.Laravel.lang.datapicker.months.february.slice(0, 2),
      window.Laravel.lang.datapicker.months.march.slice(0, 3),
      window.Laravel.lang.datapicker.months.april.slice(0, 2),
      window.Laravel.lang.datapicker.months.may.slice(0, 3),
      window.Laravel.lang.datapicker.months.june.slice(0, 3),
      window.Laravel.lang.datapicker.months.july.slice(0, 3),
      window.Laravel.lang.datapicker.months.august.slice(0, 3),
      window.Laravel.lang.datapicker.months.september.slice(0, 3),
      window.Laravel.lang.datapicker.months.october.slice(0, 2),
      window.Laravel.lang.datapicker.months.november.slice(0, 3),
      window.Laravel.lang.datapicker.months.december.slice(0, 3)
    ],
    dayNames: [
      window.Laravel.lang.datapicker.days.sunday,
      window.Laravel.lang.datapicker.days.monday,
      window.Laravel.lang.datapicker.days.tuesday,
      window.Laravel.lang.datapicker.days.wednesday,
      window.Laravel.lang.datapicker.days.thursday,
      window.Laravel.lang.datapicker.days.friday,
      window.Laravel.lang.datapicker.days.saturday
    ],
    dayNamesShort: [
      window.Laravel.lang.datapicker.days.sunday.slice(0, 3),
      window.Laravel.lang.datapicker.days.monday.slice(0, 2),
      window.Laravel.lang.datapicker.days.tuesday.slice(0, 2),
      window.Laravel.lang.datapicker.days.wednesday.slice(0, 2),
      window.Laravel.lang.datapicker.days.thursday.slice(0, 3),
      window.Laravel.lang.datapicker.days.friday.slice(0, 2),
      window.Laravel.lang.datapicker.days.saturday.slice(0, 2)
    ],
    dayNamesMin: [
      window.Laravel.lang.datapicker.days.sunday.slice(0, 1),
      window.Laravel.lang.datapicker.days.monday.slice(0, 2),
      window.Laravel.lang.datapicker.days.tuesday.slice(0, 2),
      window.Laravel.lang.datapicker.days.wednesday.slice(0, 2),
      window.Laravel.lang.datapicker.days.thursday.slice(0, 2),
      window.Laravel.lang.datapicker.days.friday.slice(0, 2),
      window.Laravel.lang.datapicker.days.saturday.slice(0, 2)
    ],
    weekHeader: window.Laravel.lang.datapicker.week,
    dateFormat: 'dd.mm.yy',
    firstDay: 1,
    isRTL: false,
    showMonthAfterYear: false,
    yearSuffix: ''
  };
  $.datepicker.setDefaults($.datepicker.regional[window.Laravel.lang.datapicker.lang]);

  if (document.querySelector('.rellax')) {
    var rellax = new Rellax('.rellax', {
      center: false,
      round: true,
      vertical: true,
      horizontal: false
    });
  }

  var didScroll = false,
    header = document.querySelector('.header'),
    body = document.querySelector('html, body'),
    ms = document.querySelector('body');

  function scrollTrue() {
    didScroll = true;
  }

  function isOnViewPoint() {
    if ((body.scrollTop || ms.scrollTop) >= 100) {
      header.classList.add('short');
    } else {
      header.classList.remove('short');
    }
  }

  window.addEventListener('scroll', scrollTrue);
  document.onscroll = scrollTrue();

  setInterval(function () {
    if (didScroll) {
      didScroll = false;
      isOnViewPoint();
    }
  });

  $(".js-up").on("click", function () {
    var body = $("html, body");
    body.stop().animate({
      scrollTop: 0
    }, 1500, 'swing');
  });
  $(window).on("scroll", function () {
    var scroll = $(window).scrollTop();
    if (scroll > 900) {
      $(".js-up").addClass("visible");
    } else {
      $(".js-up").removeClass("visible");
    }
  });


  var wow = new WOW();
  if ($(window).width() > 1024) {
    wow.init();
  } else {
    $('.wow').each(function () {
      $(this).css('visibility', 'visible');
    });
  }



});
